import { render, staticRenderFns } from "./handItem1.vue?vue&type=template&id=d49c6d50"
import script from "./handItem1.vue?vue&type=script&lang=js"
export * from "./handItem1.vue?vue&type=script&lang=js"
import style0 from "./handItem1.vue?vue&type=style&index=0&id=d49c6d50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports